// Organizations Store Module
import { createBaseModule } from './base'
import { organizationsApi } from '@/services/api'

// Custom actions for organizations
const customActions = {
  // Get members for an organization
  async getMembers({ commit }, orgId) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const members = await organizationsApi.getMembers(orgId)
      
      return members
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to fetch organization members')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Add member to organization
  async addMember({ commit, dispatch }, { orgId, userData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const member = await organizationsApi.addMember(orgId, userData)
      
      dispatch('showSuccess', 'Member added successfully', { root: true })
      
      return member
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to add member')
      dispatch('handleError', error, { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Update member role
  async updateMemberRole({ commit, dispatch }, { orgId, userId, roleData }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      const result = await organizationsApi.updateMemberRole(orgId, userId, roleData)
      
      dispatch('showSuccess', 'Member role updated successfully', { root: true })
      
      return result
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to update member role')
      dispatch('handleError', error, { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Remove member from organization
  async removeMember({ commit, dispatch }, { orgId, userId }) {
    try {
      commit('SET_LOADING', true)
      commit('CLEAR_ERROR')
      
      await organizationsApi.removeMember(orgId, userId)
      
      dispatch('showSuccess', 'Member removed successfully', { root: true })
      
      return true
    } catch (error) {
      commit('SET_ERROR', error.message || 'Failed to remove member')
      dispatch('handleError', error, { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

// Create and export the organizations module
export default createBaseModule('organization', organizationsApi, {
  customActions
})
